
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './localization/i18n'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import './style/styles.scss' // import all the styles before the app
import './style/icons' // FontAwesome and custom icons imports
import './models/js-extensions' // import JS extensions to be used globally
import { store } from './store'
import { authStore } from './store/modules/auth.store'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BTable, BTooltip } from 'bootstrap-vue-next'
import Multiselect from 'vue-multiselect'
import { dataSubscriptionStore } from './store/modules/data-subscriptions.store'
import userflow from 'userflow.js'

const app = createApp(App)

// register components
app.component('fa', FontAwesomeIcon)
app.component('multiselect', Multiselect)
app.component('b-table', BTable)
app.component('b-tooltip', BTooltip)

// register directives
app.directive('lowercase', {
  mounted(el: HTMLInputElement, binding) {
    el.addEventListener('input', () => {
      if (binding.value !== false) {
        const lowercaseValue = el.value.toLowerCase()
        if (el.value !== lowercaseValue) {
          el.value = lowercaseValue
          el.dispatchEvent(new Event('input'))
        }
      }
    })
  }
})

// set global application name
app.config.globalProperties.$appName = 'HEXIQ'

// register plugins
app.use(store)
app.use(router)
app.use(i18n)

// Error handling
app.config.errorHandler = async (error, component, info) => {
  const { azureInsightsLogger } = await import('./services/azure-insights-logger');
  azureInsightsLogger.logException(component?.$options?.name, 'Unhandled error', error);
}

window.onerror = async (msg, url, lineNo, columnNo, error) => {
  const message = [
    'Message: ' + msg,
    'URL: ' + url,
    'Line: ' + lineNo,
    'Column: ' + columnNo
  ].join(' - ');
  const { azureInsightsLogger } = await import('./services/azure-insights-logger');
  azureInsightsLogger.logException('Outside VueJs', message, error);
}

// Init
const init = async () => {
  try {
    // make sure authStore is always initialized on startup or refresh
    await authStore.init()
    // if token present, initialize stores first, and then load app
    if (authStore.decodedToken) {
      await authStore.initStores()
      const sub = dataSubscriptionStore.currentSubscription
      if (sub) {
        userflow.updateUser({
          plan_name: sub?.name ?? null,
          has_subscription: !!(sub?.active),
          subscription_states: sub?.limits?.states?.join(',') ?? null,
          subscription_expires: sub?.expires ?? null,
        })
      }
    }
  } catch (error) {
    // never leave the user on the boot spinner: mount anyway and report.
    // Route guards send them to login if the failure was auth related.
    const { azureInsightsLogger } = await import('./services/azure-insights-logger')
    azureInsightsLogger.logException('Startup', 'Store initialization failed', error)
  } finally {
    app.mount('#app')
    // Bootstrap's JS only drives the three nav dropdowns in MainHeader, so it is
    // loaded after the first paint instead of blocking it.
    void import('bootstrap/dist/js/bootstrap.bundle.min.js')
  }
}

init()
















